<template>
  <div>
    <nav>
      <v-app-bar color="white" dark app class="line">
        <img
          v-if="brandLogo !== undefined && brandLogo.length"
          :src="brandLogo"
          style="width: 15%"
          loading="lazy"
        />
        <v-spacer />

        <v-toolbar-title class="subheading pr-3 black--text"
          ><span class="grey--text">Welcome,&nbsp;</span>
          {{ userName }}</v-toolbar-title
        >

        <v-tooltip
          bottom
          v-if="
            selectedBusiness !== undefined &&
              $route.name !== 'CreateNewSubmission'
          "
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              outlined
              v-on="on"
              @click="goToBusinessSelector"
            >
              <i class="fas fa-user-circle"></i> &nbsp;
              {{ selectedBusiness.name }}
            </v-btn>
          </template>
          <span>Change Business</span>
        </v-tooltip>

        <v-tooltip left v-if="$route.name === 'Dashboard'">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="primary"
              v-on="on"
              @click="
                rightNavigationDrawerStatus = !rightNavigationDrawerStatus
              "
            >
              <v-icon>location_city</v-icon>
            </v-btn>
          </template>
          <span>Change location</span>
        </v-tooltip>
      </v-app-bar>
      <v-navigation-drawer
        v-model="leftNavigationDrawerStatus"
        mini-variant
        expand-on-hover
        permanent
        dark
        app
        class="primary"
        elevation="30"
        style="z-index: 5"
      >
        <v-list color="primary" height="65">
          <v-list-item link to="/dashboard">
            <v-list-item-icon>
              <v-icon>home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider />

        <v-list nav dense color="primary" v-if="selectedLocation">
          <template v-if="privateForms.length">
            <v-subheader>Forms</v-subheader>
            <v-list-item-group v-for="form in privateForms" :key="form.id">
              <v-list-item link @click.prevent="changeForm(form)">
                <v-list-item-icon>
                  <v-icon>assignment</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ form.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
            <v-divider />
          </template>

          <v-list-item link to="/public-forms">
            <v-list-item-icon>
              <v-icon>feed</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Public Forms</v-list-item-title>
          </v-list-item>

          <v-divider />

          <v-list-item link to="/archive" v-if="showArchive">
            <v-list-item-icon>
              <v-icon>archive</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Archived Forms</v-list-item-title>
          </v-list-item>
        </v-list>

        <template v-slot:append>
          <v-list color="primary">
            <v-list-item @click="openDeleteMDialog">
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </template>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="rightNavigationDrawerStatus"
        fixed
        right
        app
        hide-overlay
        disable-resize-watcher
        dark
        class="primary"
      >
        <v-list color="primary" class="pt-0">
          <v-list-item class="px-2 py-1 item-right">
            <v-icon
              @click="
                rightNavigationDrawerStatus = !rightNavigationDrawerStatus
              "
              >cancel</v-icon
            >
          </v-list-item>
          <v-subheader class="text-uppercase">Locations</v-subheader>
          <template v-for="(item, index) in userLocations">
            <v-list-item
              :key="item.id"
              @click="changeLocation(item)"
              :class="{ active: item.id === selectedLocation.id }"
            >
              <v-list-item-content>
                <div class="py-3">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              class="mb-0 mt-0"
              v-bind:key="`${index}-divider`"
              dark
            ></v-divider>
          </template>
          <template v-if="!userLocations.length">
            <v-list-item class="location-list">
              <v-list-item-content>
                <div class="py-3">
                  <v-list-item-title>Empty location.</v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
    </nav>

    <v-dialog :width="300" v-model="deleteDialog">
      <v-card class="mx-0 px-0">
        <v-card-title class="mx-0 pb-0">Logging out</v-card-title>
        <v-card-subtitle class="mx-0 mt-1">Are you sure?</v-card-subtitle>
        <v-card-actions class="text-center">
          <v-spacer></v-spacer>
          <v-btn text class="mr-1 lighten-1" @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn text class="mr-1 lighten-1" @click="logout">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import uiHelper from '@/helpers/ui'

export default {
  data: () => ({
    leftNavigationDrawerStatus: true,
    rightNavigationDrawerStatus: false,
    deleteDialog: false
  }),

  computed: {
    ...mapGetters({
      userBusinesses: 'user/userBusinesses',
      userLocations: 'user/userLocations',
      permissions: 'user/userPermissions',
      userData: 'auth/userData',
      privateForms: 'user/privateForms',
      publicForms: 'user/publicForms',
      brandLogo: 'business/brandLogo',
      selectedBusinessId: 'user/selectedBusinessId',
      selectedLocation: 'user/selectedLocation',
      selectedFormId: 'form/selectedFormId',
      dashboardDefaultTagId: 'form/dashboardDefaultTagId'
    }),

    selectedBusiness() {
      const selectedBusiness = this.userBusinesses.find(
        business => business.id === this.selectedBusinessId
      )
      return selectedBusiness
    },

    userName() {
      return `${this.userData.first_name} ${this.userData.last_name}` || ''
    },

    showArchive() {
      if (this.permissions?.app_permissions?.nav_bar?.show_archive) {
        return true
      } else if (this.permissions?.app_permissions?.nav_bar?.Show_Archive) {
        return true
      }
      return false
    }
  },

  watch: {
    $route() {
      this.rightNavigationDrawerStatus = false
    }
  },

  methods: {
    ...mapMutations({
      setSelectedLocation: 'user/setSelectedLocation',
      setSelectedBusinessId: 'user/setSelectedBusinessId',
      setSubmissionPageNumber: 'form/setSubmissionPageNumber',
      setSelectedForm: 'form/setSelectedForm',
      setSelectedFormId: 'form/setSelectedFormId',
      setSelectedSubmissionStats: 'form/setSelectedSubmissionStats',
      clearAllSubmissions: 'form/clearAllSubmissions',
      setSelectedStats: 'form/setSelectedStats'
    }),

    ...mapActions({
      logoutState: 'auth/logout',
      getOpenSubmissions: 'form/getOpenSubmissions',
      setSelectedBusiness: 'user/setSelectedBusiness',
      setActiveLocation: 'user/setActiveLocation',
      getBusinessDetails: 'business/getBusinessDetails',
      getMyForms: 'form/getMyForms',
      getDashboardStats: 'user/getDashboardStats'
    }),

    async changeLocation(location) {
      if (location.name === this.selectedLocation.name) {
        this.rightNavigationDrawerStatus = !this.rightNavigationDrawerStatus
        return
      }
      uiHelper.progressBarStatus(true)
      let res = await this.setActiveLocation(location)

      if (!res) return uiHelper.progressBarStatus(false)

      let formsRes = await this.getMyForms(false)
      if (formsRes) {
        let form = formsRes.data.payload.forms.find(
          el => el.id === this.selectedFormId
        )
        if (!form) form = formsRes.data.payload.forms[0]
        await this.changeForm(form)
        this.setSelectedStats({ tag_id: this.dashboardDefaultTagId })
        if (this.$route.name !== 'Dashboard') {
          this.$router.push({ name: 'Dashboard' })
        }

        // await this.getOpenSubmissions({})

        this.rightNavigationDrawerStatus = !this.rightNavigationDrawerStatus
      }
      uiHelper.progressBarStatus(false)
    },

    goToBusinessSelector() {
      this.setSelectedBusinessId('')
      this.setSelectedLocation(null)
      this.$router.push({ name: 'Business' })
    },

    async changeBusiness(businessId) {
      await this.setSelectedBusiness(businessId)
      await this.getBusinessDetails(businessId)
    },

    async changeForm(form) {
      if (this.selectedLocation) {
        uiHelper.progressBarStatus(true)
        EventBus.$emit('changeForm', form)
        this.clearAllSubmissions()
        this.setSelectedSubmissionStats({ tag_id: this.dashboardDefaultTagId })
        this.setSubmissionPageNumber(1)
        this.setSelectedFormId(form.id)
        this.setSelectedForm(form)
        try {
          await this.getDashboardStats(form.id)
          await this.getOpenSubmissions({})
          uiHelper.progressBarStatus(false)
        } catch (error) {
          uiHelper.progressBarStatus(false)
          uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        }
        if (this.$route.name !== 'Dashboard')
          this.$router.push({ name: 'Dashboard' })
      } else {
        uiHelper.showSnackbarMessage('Please select a location', 'error')
      }
    },

    openDeleteMDialog() {
      this.deleteDialog = true
    },

    logout() {
      this.logoutState()
      this.$store.reset()
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>
